import React from "react";
import ListarJogosPage from "./ListarJogosPage";

const ListarJogosPageView = () => <ListarJogosPage admin={false} />;

export default ListarJogosPageView;
